export default __webpack_public_path__ + "static/media/proximanova-semibold.596875d3.WOFF";